export enum MarketingMenuType {
  Looping = 'LOOPING_CONTENT_MENU',
  SmartPlaylist = 'PRODUCT_LINKED_LOOPING_CONTENT_MENU',
  Featured = 'FEATURED_PRODUCT_MENU',
  DriveThru = 'FEATURED_PRODUCT_COMBO_MENU',
  Category = 'FEATURED_CATEGORY_MENU',
  UrlPlaylist = 'URL_PLAYLIST_MENU'
}
